import { Button, styled } from '@mui/material';
import { NavLink } from 'react-router';
import dashboardHero from '../../assets/images/dashboard-hero.png';

const DashboardHeroWrapper = styled('div')({
  background: 'linear-gradient(94deg, #1b437f -21.51%, #021635 101.1%)',
  borderRadius: '12px',
  padding: '50px 64px',
  margin: '16px',
  color: '#fff',
  display: 'flex',
  justifyContent: 'space-between',
});

function DashboardHero() {
  return (
    <DashboardHeroWrapper>
      <div>
        <h1 style={{ marginTop: 0, marginBottom: '24px', fontSize: '30px' }}>Start a new Search</h1>
        <p style={{ marginTop: 0, marginBottom: 0 }}>
          The data tool helps you analytical insights <br /> by creating of cases
        </p>
        <NavLink to='/case-details'>
          <Button
            variant='contained'
            sx={{
              background: '#FFF',
              color: 'primary.main',
              padding: '10px 48px',
              fontSize: '16px',
              fontWeight: 600,
              marginTop: '54px',
            }}
            id='tour-new-case-button'
          >
            New
          </Button>
        </NavLink>
      </div>
      <div style={{ position: 'relative' }}>
        <img
          style={{ position: 'absolute', bottom: '-25%', right: '0%' }}
          src={dashboardHero}
          alt='Dashboard hero background'
        />
      </div>
    </DashboardHeroWrapper>
  );
}

export default DashboardHero;
